"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_CARD_BRANDS = exports.FRAMEPAY_STYLE_LINK = exports.FRAMEPAY_SCRIPT_LINK = exports.REACT_VERSION = void 0;

var React = __importStar(require("react"));
/**
 *
 * Constants file.
 * Links to the remote library FramePay and other settings.
 *
 */

/**
 * The ReactJS version 14+
 * used in context.ts
 */


exports.REACT_VERSION = React.version;
/**
 * Remote FramePay library CDN link.
 */

exports.FRAMEPAY_SCRIPT_LINK = process.env.FRAMEPAY_SCRIPT_LINK || 'https://framepay.rebilly.com/rebilly.js';
/**
 * Remote FramePay style CDN link.
 */

exports.FRAMEPAY_STYLE_LINK = process.env.FRAMEPAY_STYLE_LINK || 'https://framepay.rebilly.com/rebilly.css';
/**
 * Supported FramePay card types
 */

exports.SUPPORTED_CARD_BRANDS = {
  Amex: "American Express"
  /* Amex */
  ,
  AstroPayCard: "AstroPay Card"
  /* AstroPayCard */
  ,
  Cup: "ChinaUnionPay"
  /* Cup */
  ,
  DinersClub: "Diners Club"
  /* DinersClub */
  ,
  Discover: "Discover"
  /* Discover */
  ,
  JCB: "JCB"
  /* JCB */
  ,
  Maestro: "Maestro"
  /* Maestro */
  ,
  MasterCard: "MasterCard"
  /* MasterCard */
  ,
  Visa: "Visa"
  /* Visa */

};